export default __webpack_public_path__ + "static/wrapped1-f4d419796dae1854b94e6a68dfe69a0d.jpg";